import { requestFromServer } from "./api-client";

const TimeBlocks = {
  listByBranch: async (idBranch, date = null, getAllTimeBlocks = null, idTurn = null) => {
    if (!!date) {
      if (!!getAllTimeBlocks) {
        if (!!idTurn) {
          return requestFromServer(`v1/Time_Blocks/list/${idBranch}/${date}/${getAllTimeBlocks}/${idTurn}`);
        }
        return requestFromServer(`v1/Time_Blocks/list/${idBranch}/${date}/${getAllTimeBlocks}`);
      }
      return requestFromServer(`v1/Time_Blocks/list/${idBranch}/${date}`);
    }
    return requestFromServer(`v1/Time_Blocks/list/${idBranch}`);
  },
  listByDateInterval: async (idBranch, startDate, endDate) => {
    return requestFromServer(`v1/Time_Blocks/listByDateInterval/${idBranch}/${startDate}/${endDate}`);
  },
  listAvailableByDate: async (date, idPlant, idProduct, idLoadType, clientDocumentNumber, transporterCNPJ) => {
    return requestFromServer(
      `v1/Time_Blocks/listAvailableByDate/${date}/${idPlant}/${idProduct}/${idLoadType}?cnpj=${clientDocumentNumber}${transporterCNPJ ? `&transporter_cnpj=${transporterCNPJ}` : ''}`
    );
  },
  add: async (timeBlock) => {
    return requestFromServer(`v1/Time_Blocks/add`, "POST", timeBlock);
  },
  update: async (timeBlock) => {
    return requestFromServer(
      `v1/Time_Blocks/update/${timeBlock.id}`,
      "PUT",
      timeBlock
    );
  },
  delete: async (id, date = null) => {
    if (date)
      return requestFromServer(`v1/Time_Blocks/delete/${id}/${date}`, "delete");
    else
      return requestFromServer(`v1/Time_Blocks/delete/${id}`, "delete");
  },
};

export default TimeBlocks;
